import { animated, useSpring } from '@react-spring/web';

export function SignatureSuccess() {
  const styles = useSpring({
    from: { scale: 0, opacity: 0 },
    to: { scale: 1, opacity: 1 },
    config: { tension: 180, friction: 12 },
  });

  return (
    <div className="flex flex-col items-center justify-center py-8">
      <animated.div style={styles}>
        <svg
          className="w-20 h-20 text-green-500 mb-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="#22c55e22" />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8 12l3 3 5-5"
            stroke="#22c55e"
            strokeWidth="2.5"
            fill="none"
          />
        </svg>
      </animated.div>
      <div className="text-xl font-semibold text-success-500 mb-2 text-center">
        Deine Unterschrift wurde erfolgreich gespeichert!
      </div>
      <div className="text-gray-600 text-center">Du kannst dieses Fenster jetzt schließen.</div>
    </div>
  );
}
